import React, {useContext} from "react";
import {Link} from "react-router-dom";
import {Contact} from "./index";
import {ContentContext} from "../../ContentContext";
import {getDirectusImage} from "../../api/directus";

function Footer() {
    const data = useContext(ContentContext);
    const logoUrl = getDirectusImage(data?.footerLogo);

    return (
        <footer className={"footer"}>
            <img
                className={"footer-top-background"}
                src={"/assets/background_footer.png"}
                alt={"Footer Top Background"}
                loading={"lazy"}
            />
            <div className={"footer-top"}>
                <div className={"footer-column-left"}>
                    <Link to={data?.footerLogoLinkUrl}>
                        <img
                            className={"logo hover-move"}
                            src={logoUrl}
                            alt={`${data?.companyName} logo`}
                            loading={"lazy"}
                        />
                    </Link>
                    <div className={"footer-quote"} dangerouslySetInnerHTML={{__html: data?.slogan}} />
                </div>
                <div className={"footer-column-right"}>
                    <Contact />
                </div>
            </div>
            <div className={"footer-bottom"}>
                <ul className={"footer-bottom-links"}>
                    {data?.footerBottomBarLinks &&
                        data.footerBottomBarLinks?.map((item, index) => (
                            <li key={index}>
                                <Link to={`/${item?.routeID}`}>{item?.title}</Link>
                            </li>
                        ))}
                </ul>
                <div className={"footer-copyright"}>
                    &copy; {new Date().getFullYear()} {data?.companyName}. {data?.copyrightAdditionalText}
                </div>
            </div>
        </footer>
    );
}

export default Footer;
